// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/modules/_enum-bug-keys.js
// module id = 169
// module chunks = 48 49 50 51